import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { loadVariableDosage, loadVariableDosageFailure, loadVariableDosageSuccess } from './variable-dosage.actions';
import { VariableDosageApiService } from './variable-dosage.api.service';

@Injectable()
export class VariableDosageEffects {
  constructor(
    private actions$: Actions,
    private api: VariableDosageApiService,
  ) {}

  load$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadVariableDosage),
      mergeMap((action) =>
        this.api
          .getVariableDosage(
            action.applicationCode,
            action.country,
            action.subgroup,
            action.deliveryDate,
            action.commProduct,
          )
          .pipe(
            map((data) => loadVariableDosageSuccess({ key: action.key, data })),
            catchError((error) => of(loadVariableDosageFailure({ key: action.key, error }))),
          ),
      ),
    ),
  );
}
